module.exports = __webpack_public_path__ + "img/AI-banner.a68a2036.png";